module.exports = __webpack_public_path__ + "img/g0067.6ea34324.png";